import "./App.css";
import "@rainbow-me/rainbowkit/styles.css";
import { getDefaultWallets, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { alchemyProvider } from "wagmi/providers/alchemy";
import { publicProvider } from "wagmi/providers/public";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  mainnet,
  polygon,
  optimism,
  arbitrum,
  sepolia,
  bscTestnet,
} from "wagmi/chains";
import HomePage from "./components/homepage/HomePage";
import { Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import RecentListing from "./components/Recent Listning/RecentListing";
import LandDetail from "./components/Land Detail/LandDetail";
import SignIn from "./components/account/signIn/signIn";
import CreateAccount from "./components/account/createAcc/CreateAccount";
import Marketplace from "./components/Market Place/MarketPlace";
import ProfileTabs from "./components/Profile/ProfileTabs";
import Footer from "./components/footer/Footer";
// import TileGrid from "./components/map/map";
import Grid from "./components/map/map";
import CanvasModel from "./components/ButtonModels/Canvas-Model/CanvasModel";
import RecentSales from "./components/Recent Sales/RecentSales";
import NoLandAvailable from "./components/No Land Available/NoLandAvailable";
import ProfileInventoryModel from "./components/ButtonModels/Profile-inventory-Model/ProfileInventoryModel";
import Table from "./components/Table/Table";
import LandDetailModel from "./components/ButtonModels/LandDetail-Model/LandDetailModel";
import InventoryLandDetails from "./components/Inventory Land Details/InventoryLandDetails";
import BuyLand from "./components/buyland";

const { chains, publicClient } = configureChains([sepolia], [publicProvider()]);

const { connectors } = getDefaultWallets({
  appName: "astrality",
  projectId: "095dcb29cb26ea6eeecd2ba2c22873bb",
  chains,
});
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
});

function App() {
  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider chains={chains}>
        <ToastContainer />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/" element={<HomePage />} /> */}
          <Route path="/map" element={<Grid />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/sign-up" element={<CreateAccount />} />
          <Route path="/recent-listing" element={<RecentListing />} />
          <Route path="/recent-sales" element={<RecentSales />} />
          <Route path="/account" element={<ProfileTabs />} />
          <Route path="/land-detail" element={<LandDetail />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/canvas" element={<CanvasModel />} />
          <Route path="/noland" element={<NoLandAvailable />} />
          <Route
            path="/ProfileInventoryModel"
            element={<ProfileInventoryModel />}
          />
          <Route path="/table" element={<Table />} />
          <Route path="/LandDetail-model" element={<LandDetailModel />} />
          <Route
            path="/InventoryLandDetails"
            element={<InventoryLandDetails />}
          />
          <Route path="/buyland" element={<BuyLand />} />
        </Routes>

        <Footer />
      </RainbowKitProvider>
    </WagmiConfig>
  );
}

export default App;
